'use client';

import { cn } from '../../lib/utils';
import { hoodiePaths } from './legacyPaths';

const PE_AUTO = { pointerEvents: 'auto' } as const;

/** Collar positioning within the full body viewBox */
const COLLAR_POSITION = { left: '37.97%', top: '59.86%', width: '24.25%', height: '5.3%' };

interface LegacyRainaHoodBottomProps {
  svgId: string;
  idleAnimations?: boolean;
}

export function LegacyRainaHoodBottom({ svgId, idleAnimations = true }: LegacyRainaHoodBottomProps) {
  const id = (name: string) => `${svgId}${name}`;

  return (
    <div className="absolute inset-0 pointer-events-none">
      {/* Hoodie Collar */}
      <div className="absolute flex items-center justify-center" style={COLLAR_POSITION}>
        <div className="flex-none rotate-180 -scale-y-100 w-full h-full">
          <svg aria-hidden="true" className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 103.772 34.6303">
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id={id('rightCollarGrad')}
                x1="-23.1558"
                x2="-30.8304"
                y1="-19.5318"
                y2="26.036"
              >
                <stop stopColor="#C8A8FF" />
                <stop offset="1" stopColor="#A97AFF" />
              </linearGradient>
              <linearGradient gradientUnits="userSpaceOnUse" id={id('leftCollarGrad')} x1="126.927" x2="134.602" y1="-19.8228" y2="25.745">
                <stop stopColor="#C8A8FF" />
                <stop offset="1" stopColor="#A97AFF" />
              </linearGradient>
            </defs>
            <path d={hoodiePaths.rightCollar} fill={`url(#${id('rightCollarGrad')})`} data-region="body" style={PE_AUTO} />
            <path d={hoodiePaths.leftCollar} fill={`url(#${id('leftCollarGrad')})`} data-region="body" style={PE_AUTO} />
          </svg>
        </div>
      </div>
      {/* Right Hoodie String */}
      <div
        className={cn('absolute', idleAnimations && 'motion-safe:animate-[raina-string-sway_3s_ease-in-out_infinite]')}
        style={{ left: '53.26%', top: '63.15%', width: '2.06%', height: '4.92%', transformOrigin: 'top center' }}
      >
        <div className="absolute inset-[-11.9%_-34.87%_-7.94%_-43.41%]">
          <svg aria-hidden="true" className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.743 38.5875">
            <path
              d={hoodiePaths.stringCurve}
              stroke="#33116F"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="7.6664"
              data-region="body"
              style={PE_AUTO}
            />
            <path
              d={hoodiePaths.stringTailRight}
              stroke="#33116F"
              strokeLinecap="round"
              strokeWidth="5.11094"
              data-region="body"
              style={PE_AUTO}
            />
          </svg>
        </div>
      </div>
      {/* Left Hoodie String */}
      <div
        className={cn(
          'absolute flex items-center justify-center',
          idleAnimations && 'motion-safe:animate-[raina-string-sway_3s_ease-in-out_infinite_0.5s]',
        )}
        style={{ left: '44.89%', top: '63.15%', width: '2.1%', height: '4.92%', transformOrigin: 'top center' }}
      >
        <div className="flex-none rotate-180 -scale-y-100 w-full h-full">
          <div className="absolute inset-[-11.9%_-32.33%_-7.94%_-42.59%]">
            <svg aria-hidden="true" className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.743 38.5875">
              <path
                d={hoodiePaths.stringCurve}
                stroke="#33116F"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="7.6664"
                data-region="body"
                style={PE_AUTO}
              />
              <path
                d={hoodiePaths.stringTailLeft}
                stroke="#33116F"
                strokeLinecap="round"
                strokeWidth="5.11094"
                data-region="body"
                style={PE_AUTO}
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
